<template>
  <md-card-content>
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100"><label>利用規約の確認</label>
      </div>
      <div class="md-layout-item">
        <md-button :disabled="!activated || sending" @click="openTerms" class="md-primary md-raised">
          <md-icon>list_alt</md-icon>
          <span>シカクマップ 利用規約</span>
        </md-button>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item">
        <md-checkbox :disabled="!activated || sending || !form.isReadTerms" class="md-primary" id="checkAccept" v-model="form.apply">
          上記利用規約に同意します
        </md-checkbox>
        <flash-message :errors="[unapplyMessage]"
                       v-if="validated !== null && !$v.form.apply.mustBeTrue"></flash-message>
        <flash-message :errors="[getValidationResponseMessage('apply')]"
                       v-else-if="getValidationResponseMessage('apply')"></flash-message>
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-20 md-small-size-100"></div>
      <div class="md-layout-item">
        <p class="md-caption">
          ご入力いただいた個人情報の取り扱い詳細は<a href="https://www.jon.co.jp/privacy/" rel="noopener" :disabled="!activated"
                                 target="_blank">プライバシーポリシー</a>をご覧ください。<br>
          申し込みをもって、これにご同意いただいたものとみなします。
        </p>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import FlashMessage      from "../FlashMessage";
import ContractFormMixin from "../../mixins/contractFormMixin";
import CommonMixin       from "../../mixins/commonMixin";
import {validationMixin} from "vuelidate";
import Common            from "../../modules/common";
import Validation        from "../../modules/validation";

export default {
  name      : 'ContractFormTerm',
  components: {FlashMessage},
  mixins    : [CommonMixin, ContractFormMixin, validationMixin],
  props     : ['value', 'activated'],
  data      : () => ({
    form          : {
      isReadTerms: false,
      apply      : false,
    },
    unapplyMessage: Common.messages.apply.failure,
  }),
  validations() {
    return {
      form: {
        apply: {
          mustBeTrue: Validation.mustBeTrue,
        },
      },
    }
  },
  methods: {
    openTerms() {
      window.open('/terms', '_blank');
      this.form.isReadTerms = true;
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
